import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import EntitiesViewBar from 'components/organisms/Bars/EntitiesViewBar/EntitiesViewBar';

const StyledDealflowEntitiesViewBar = styled(EntitiesViewBar)`
  ${ComponentStyles}
`;

StyledDealflowEntitiesViewBar.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntitiesViewBar;
